import { render, staticRenderFns } from "./ConfigSMS.vue?vue&type=template&id=66b69a5e&"
import script from "./ConfigSMS.vue?vue&type=script&lang=js&"
export * from "./ConfigSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports